export const Table = {
    START_CELL_EDIT: "table.cell.edit.start",
    STOP_CELL_EDIT: "table.cell.edit.stop",
    SET_SELECTED_NODE: "table.node.set-selected",
    SET_COLUMN_STATE: "table.column.state.set",
};
